/* src/app/price-list/pages/price-list/price-list.component.scss */
/*# sourceMappingURL=price-list.component.css.map */
